import { WARRANTY_VALUE, DOMESTIC_LARGE_WARRANTY_CODES, IMPORTED_LARGE_WARRANTY_CODES } from 'app/constants/escrow-v2';

// 기본 보증 개월수 — 국산 대형/특대형 12, 수입 대형·스포츠카/특대형 9, 그 외 6 (buy 홈서비스와 동일 정책)
export const getDefaultWarrantyMonth = (warrantyList = []) => {
	if (warrantyList.some(({ code }) => DOMESTIC_LARGE_WARRANTY_CODES.includes(code))) return WARRANTY_VALUE.TWELVE;
	if (warrantyList.some(({ code }) => IMPORTED_LARGE_WARRANTY_CODES.includes(code))) return WARRANTY_VALUE.NINE;

	return WARRANTY_VALUE.SIX;
};

// 견적 금액 계산. 보증비는 선택 개월수로 조회한 견적 API 응답의 extendedWarrantyCost 를 쓴다 (buy 홈서비스와 동일)
export class MeetgoEstimate {
	constructor({ estimate }) {
		this.estimate = estimate || {
			carPrice: 0,
			transferCost: 0,
			sellingCost: 0,
			userFee: 0,
			inspectionInsuranceFee: 0,
			extendedWarrantyCost: 0,
		};
	}

	getIncidentalExpenses() {
		const { transferCost, sellingCost, inspectionInsuranceFee } = this.estimate;

		return transferCost + sellingCost + inspectionInsuranceFee;
	}

	getTotalCost() {
		const { carPrice, userFee, extendedWarrantyCost = 0 } = this.estimate;

		const incidentalExpenses = this.getIncidentalExpenses();

		return carPrice + userFee + incidentalExpenses + extendedWarrantyCost;
	}
}

export default null;
